export default __webpack_public_path__ + "static/SOC_NonCPA_white-7eaf6c9a07de7ce6f4e0843a1ddd0f07.svg";